import { Grid, Link } from "@mui/material";
import { Container } from "@mui/system";
import aquatraining from "../../assets/images/activites/Vitaleau-Montage-Generique.webp";
import adulteVitaleau from "../../assets/images/Vitaleau-Montage-Adultes-inscription.png";
import bebeVitaleau from "../../assets/images/Vitaleau-Montage-Bebes-inscription.png";
import enfantVitaleau from "../../assets/images/Vitaleau-Montage-Enfants-inscription.png";
import { Button } from "../../stories/atoms/Button";

export const GoPloof = ({ profil }) => {
    const showAll = !profil; // ✅ si aucun profil n'est fourni (page générale)

    const profilClass = showAll
        ? "profil-all"
        : profil === "bébé"
        ? "profil-bebe"
        : profil === "enfant"
        ? "profil-enfant"
        : profil === "adulte" || profil === "sénior"
        ? "profil-adulte"
        : "profil-default";

    return (
        <section className={`vitaleau-section-goploof ${profilClass}`}>
            <div
                style={{
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundImage: `url(${aquatraining})`,
                }}
                id="insrcire"
            >
                <Container maxWidth="xl">
                    <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12}>
                            <div className="vitaleau-section-goploof-inner">
                                <h2 data-title="Prêt à vous jeter à l’eau ?">Prêt à vous jeter à l’eau ?</h2>

                                {/* 🟢 Bloc texte inscription */}
                                <div className="section-info-inscription">
                                    {/* Bloc Adultes + Séniors */}
                                    {(showAll || profil === "adulte" || profil === "sénior") && (
                                        <div className="info-inscription-inner">
                                            <h3>Activités adultes et séniors</h3>
                                            <p>
                                                Inscription directement en ligne sur le site ou l’application Résamania. <br /> <br />
                                                Une fois votre compte créé, vous pouvez réserver vos séances :
                                            </p>
                                            <ul>
                                                <li>
                                                    À partir de votre espace membre{" "}
                                                    <Link
                                                        href="https://member.resamania.com/vitaleau-verrieresantony/"
                                                        alt="Lien vers le site membre Résamania"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Résamania
                                                    </Link>
                                                </li>
                                                <li>
                                                    Ou avec un smartphone via l’application RésamaniaV2, sur l'{" "}
                                                    <Link
                                                        href="https://apps.apple.com/fr/app/resamania-v2/id1482410619"
                                                        alt="Lien App Store Résamania"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Apple App Store
                                                    </Link>{" "}
                                                    et sur le{" "}
                                                    <Link
                                                        href="https://play.google.com/store/apps/details?id=com.resamania.resamaniav2&hl=fr&gl=US"
                                                        alt="Lien Play Store Résamania"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Google Play Store
                                                    </Link>
                                                    .
                                                </li>
                                            </ul>
                                        </div>
                                    )}

                                    {/* Bloc Enfants + Bébés */}
                                    {(showAll || profil === "enfant" || profil === "bébé") && (
                                        <div className="info-inscription-inner">
                                            <h3>Activités Enfants et Bébés</h3>
                                            <p>
                                                Téléchargez ci-dessous la fiche d’inscription qui vous correspond. Remplissez les infos personnelles.
                                                Venez avec à la piscine pour finaliser le tout.
                                                <br /> <br /> Les règlements se font uniquement par chèques. <br /> <br />
                                                Attention pour les inscriptions enfants de plus de 4 ans, un test est obligatoire avant validation —
                                                donc n’oubliez pas ses affaires de piscine. 🙂
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* 🟣 Bloc des cartes / fiches */}
                                <div className="vitaleau-section-grid-goploof">
                                    {/* Adultes + Séniors */}
                                    {(showAll || profil === "adulte" || profil === "sénior") && (
                                        <Link
                                            href="https://member.resamania.com/vitaleau-verrieresantony/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="containavtivitypiscine"
                                        >
                                            <img
                                                src={adulteVitaleau}
                                                alt="Vital'eau Verrières-Antony Adultes"
                                                title="Vital'eau Verrières-Antony Adultes"
                                                loading="lazy"
                                                width={238}
                                                height={230}
                                            />
                                            <p>Adultes & Séniors</p>
                                            <Button
                                                label="Inscription"
                                                style={{ width: "fit-content" }}
                                                primary
                                                href="https://member.resamania.com/vitaleau-verrieresantony/"
                                                target="_blank"
                                                rel="noreferrer"
                                            />
                                        </Link>
                                    )}

                                    {/* Enfants */}
                                    {(showAll || profil === "enfant") && (
                                        <Link
                                            href="/vitaleau-fiche-inscription-enfants.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="containavtivitypiscine"
                                        >
                                            <img
                                                src={enfantVitaleau}
                                                alt="Vital'eau Verrières-Antony Enfants"
                                                title="Vital'eau Verrières-Antony Enfants"
                                                loading="lazy"
                                                width={238}
                                                height={230}
                                            />
                                            <p>Enfants</p>
                                            <Button
                                                label="Télécharger la fiche"
                                                style={{ width: "fit-content" }}
                                                primary
                                                href="/vitaleau-fiche-inscription-enfants.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            />
                                        </Link>
                                    )}

                                    {/* Bébés */}
                                    {(showAll || profil === "bébé") && (
                                        <Link
                                            href="/vitaleau-fiche-inscription-bebes.pdf"
                                            target="_blank"
                                            rel="noreferrer"
                                            className="containavtivitypiscine"
                                        >
                                            <img
                                                src={bebeVitaleau}
                                                alt="Vital'eau Verrières-Antony Bébés"
                                                title="Vital'eau Verrières-Antony Bébés"
                                                loading="lazy"
                                                width={238}
                                                height={230}
                                            />
                                            <p>Bébés</p>
                                            <Button
                                                label="Télécharger la fiche"
                                                style={{ width: "fit-content" }}
                                                primary
                                                href="/vitaleau-fiche-inscription-bebes.pdf"
                                                target="_blank"
                                                rel="noreferrer"
                                            />
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </section>
    );
};
